var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v("\n    " + _vm._s(_vm.showopenmodalcomp) + "\n    "),
      _vm.showopenmodal
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c("div", { staticClass: "modal-mask" }, [
                  _c("div", { staticClass: "modal-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "modal-dialog modal-md",
                        staticStyle: { display: "block !important" },
                      },
                      [
                        _c("div", { staticClass: "modal-content" }, [
                          _c("div", { staticClass: "modal-header pb-0" }, [
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "modal-title text-center pull-left w-100 d-block mt-4 pb-0",
                              },
                              [
                                _vm._v(
                                  "\n                                    OPD Card Settings\n                                "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "close",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancelAction()
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("close"),
                                ]),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "modal-body p-0" }, [
                            _c("div", [
                              _vm.showspinner
                                ? _c(
                                    "div",
                                    { staticClass: "appointmentlist-spinner" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "processing_popup full-spinner",
                                          staticStyle: {
                                            visibility: "visible",
                                            top: "-68px",
                                            height: "261px",
                                            "z-index": "9999999999",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "spinner cover-spin",
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "bounce1",
                                              }),
                                              _c("div", {
                                                staticClass: "bounce2",
                                              }),
                                              _c("div", {
                                                staticClass: "bounce3",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "col-md-12" },
                                _vm._l(_vm.sections, function (section) {
                                  return _c(
                                    "label",
                                    {
                                      key: section.value,
                                      staticClass:
                                        "container customcheck mart-10 float-none",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(section.label)),
                                      ]),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedSections,
                                            expression: "selectedSections",
                                          },
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: section.value,
                                          checked: Array.isArray(
                                            _vm.selectedSections
                                          )
                                            ? _vm._i(
                                                _vm.selectedSections,
                                                section.value
                                              ) > -1
                                            : _vm.selectedSections,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.selectedSections,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = section.value,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.selectedSections =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.selectedSections = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.selectedSections = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _c("span", { staticClass: "checkmark" }),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _c("div", { staticClass: "col-md-12 mt-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "container customcheck mart-10 float-none",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Display Custom OPD Timings Text?"
                                      ),
                                    ]),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.displayCustomOpdTimingText,
                                          expression:
                                            "displayCustomOpdTimingText",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.displayCustomOpdTimingText
                                        )
                                          ? _vm._i(
                                              _vm.displayCustomOpdTimingText,
                                              null
                                            ) > -1
                                          : _vm.displayCustomOpdTimingText,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.displayCustomOpdTimingText,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.displayCustomOpdTimingText =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.displayCustomOpdTimingText =
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.displayCustomOpdTimingText = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _c("span", { staticClass: "checkmark" }),
                                  ]
                                ),
                              ]),
                              _vm.displayCustomOpdTimingText
                                ? _c("div", { staticClass: "col-md-12 mt-2" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.customOpdTimingText,
                                          expression: "customOpdTimingText",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        placeholder:
                                          "Enter custom OPD timing text",
                                        maxlength: "100",
                                      },
                                      domProps: {
                                        value: _vm.customOpdTimingText,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.customOpdTimingText =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.customOpdTimingText.length
                                          ) +
                                          "/100\n                                        "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "col-md-12 mt-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "container customcheck mart-10 float-none",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Display Vitals in Single Line?"),
                                    ]),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.displayVitalsInSingleLine,
                                          expression:
                                            "displayVitalsInSingleLine",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.displayVitalsInSingleLine
                                        )
                                          ? _vm._i(
                                              _vm.displayVitalsInSingleLine,
                                              null
                                            ) > -1
                                          : _vm.displayVitalsInSingleLine,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.displayVitalsInSingleLine,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.displayVitalsInSingleLine =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.displayVitalsInSingleLine =
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.displayVitalsInSingleLine = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _c("span", { staticClass: "checkmark" }),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-12 mt-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "container customcheck mart-10 float-none",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Display serial number ?"),
                                    ]),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.displaySerialNumber,
                                          expression: "displaySerialNumber",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.displaySerialNumber
                                        )
                                          ? _vm._i(
                                              _vm.displaySerialNumber,
                                              null
                                            ) > -1
                                          : _vm.displaySerialNumber,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.displaySerialNumber,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.displaySerialNumber =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.displaySerialNumber = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.displaySerialNumber = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _c("span", { staticClass: "checkmark" }),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pull-left mb-4 pl-5 pr-5 col-md-12 mt-2",
                                },
                                [
                                  _vm._t("footer", function () {
                                    return [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "primary-btn ripple pull-right",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.saveSettings()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                Save\n                                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isdisplaymsg
        ? _c("Messages", {
            attrs: {
              datamessage: _vm.sucessmsgtext,
              iserror: _vm.iserrormsg,
              isVisible: _vm.isdisplaymsg,
            },
            on: { closemsg: _vm.closeMessage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }